var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconArray = function SvgMiconArray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M26 28h-4v-2h4V6h-4V4h4a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2M10 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4v2H6v20h4zM16.254 23.227c.874 0 1.254-.494 1.254-1.178v-.285c0-.684-.38-1.178-1.254-1.178S15 21.08 15 21.764v.285c0 .684.38 1.178 1.254 1.178M12.254 23.227c.874 0 1.254-.494 1.254-1.178v-.285c0-.684-.38-1.178-1.254-1.178S11 21.08 11 21.764v.285c0 .684.38 1.178 1.254 1.178M20.254 23.227c.874 0 1.254-.494 1.254-1.178v-.285c0-.684-.38-1.178-1.254-1.178S19 21.08 19 21.764v.285c0 .684.38 1.178 1.254 1.178"
  })));
};
export default SvgMiconArray;